import React from 'react';
import { Spinner } from '../../components/ui';
import { fmtDate } from '../../utils/helpers';
import FunctionForm from './FunctionForm';

// Desktop Functions UI — a table. Add/Edit/Del are Owner/Event-Admin only.
export default function FunctionsDesktop({ vm }) {
  const { filtered, days, loading, columns, can, q, setQ, startAdd, startEdit, del } = vm;
  const showActions = can.edit || can.delete;
  return (
    <div>
      <div className="page-head">
        <h1>Functions</h1>
        <span className="muted">{filtered.length}</span>
        <div className="spacer" />
        <input placeholder="Search…" value={q} onChange={(e) => setQ(e.target.value)}
          style={{ padding: '9px 12px', border: '1px solid var(--line)', borderRadius: 10, maxWidth: 200 }} />
        {can.add && <button className="btn primary" onClick={startAdd}>+ Add Function</button>}
      </div>

      {loading ? <div className="card card-pad"><Spinner /></div> : filtered.length === 0 ? (
        <div className="card card-pad empty">No functions yet.{!can.add && ' Ask the Event Owner to add functions.'}</div>
      ) : days.map(day => (
        /* One block per day, functions inside it in time order. */
        <div key={day.date || 'nodate'} style={{ marginBottom: 14 }}>
          <div className="step-label">{day.date ? fmtDate(day.date) : 'No date yet'}{day.items.length > 1 ? ` · ${day.items.length} functions` : ''}</div>
          <div className="card table-wrap">
          <table className="tbl compact">
            <thead>
              <tr>
                {columns.map(c => <th key={c.key}>{c.label}</th>)}
                {showActions && <th></th>}
              </tr>
            </thead>
            <tbody>
              {day.items.map(row => (
                <tr key={row.FunctionId} className="row-link"
                  title={day.clashes.has(row.FunctionId) ? 'This time overlaps another function on the same day' : 'Open guests of this function'}
                  style={day.clashes.has(row.FunctionId) ? { background: 'color-mix(in srgb, var(--danger) 8%, transparent)' } : undefined}
                  onClick={() => vm.openRow(row)}>
                  {columns.map(c => <td key={c.key}>{c.render ? c.render(row) : (row[c.key] ?? '—')}</td>)}
                  {showActions && (
                    <td style={{ textAlign: 'right' }} onClick={(e) => e.stopPropagation()}>
                      {can.edit && <button className="btn light sm" onClick={() => startEdit(row)}>Edit</button>}
                      {can.delete && <button className="btn danger sm" style={{ marginLeft: 6 }} onClick={() => del(row)}>Del</button>}
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </div>
      ))}

      <FunctionForm vm={vm} event={vm.event} />
    </div>
  );
}
